import jQuery from 'jquery';

const TOOLBAR_BUTTONS = [
  'bold',
  'italic',
  'underline',
  'strikeThrough',
  'subscript',
  'superscript',
  'fontFamily',
  'fontSize',
  'color',
  'paragraphFormat'
];

const DISALLOWED_TAGS = [
  'area', 'audio',
  'base',
  'canvas',
  'datalist', 'details', 'dialog',
  'embed',
  'figcaption', 'figure',
  'hgroup',
  'iframe',
  'keygen',
  'link',
  'map', 'menu', 'menuitem', 'meter',
  'noscript',
  'object', 'output',
  'param', 'progress',
  'queue',
  'rp', 'rt', 'ruby',
  'script', 'style', 'source', 'summary',
  'title', 'track',
  'video'
];

const ALLOWED_TAGS = [
  'a', 'abbr', 'address', 'article', 'aside',
  'b', 'bdi', 'bdo', 'blockquote', 'button', 'br',
  'caption', 'cite', 'code', 'col', 'colgroup',
  'dd', 'del', 'dfn', 'div', 'dl', 'dt',
  'em',
  'fieldset', 'font', 'form', 'footer', // Remove with PB-2214
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hr',
  'i', 'img', 'input', 'ins',
  'kbd',
  'label', 'legend', 'li',
  'main', 'mark',
  'nav',
  'ol', 'optgroup', 'option',
  'p', 'pre',
  's', 'samp', 'small', 'section', 'select', 'span', 'strike', 'strong', 'sub', 'sup',
  'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr',
  'u', 'ub:dynamic', 'ub:clientsidedynamic', 'ul',
  'var',
  'wbr'
];

const ALLOWED_ATTRS = jQuery.FroalaEditor.DEFAULTS.htmlAllowedAttrs.concat([
  'color', // Remove with PB-2214
  'contenteditable',
  'face', // Remove with PB-2214
  'method',
  'parameter',
  'size', // Remove with PB-2214
  'wrap'
]);

const ALLOWED_SHORTKEYS = [
  'bold', 'italic', 'underline',
  'undo', 'redo'
];

export default {
  charCounterCount: false,
  codeMirrorOptions: {
    lineWrapping: true,
    theme: 'material'
  },
  htmlAllowedTags: ALLOWED_TAGS,
  htmlRemoveTags: DISALLOWED_TAGS,
  htmlAllowedAttrs: ALLOWED_ATTRS,
  keepFormatOnDelete: true,
  toolbarButtons: TOOLBAR_BUTTONS,
  toolbarButtonsMD: TOOLBAR_BUTTONS,
  toolbarButtonsSM: TOOLBAR_BUTTONS,
  toolbarButtonsXS: TOOLBAR_BUTTONS,
  shortcutsEnabled: ALLOWED_SHORTKEYS,
  toolbarInline: true,
  toolbarVisibleWithoutSelection: true,
  typingTimer: 500, // debounce on contentChanged being called (ms)
};



// WEBPACK FOOTER //
// ./src/froala-option-config.js